import OrderLineOperators from './OrderLineOperators';
import AppError from '../libraries/AppError';
import { alphaCharacters, copyObject, isSpecificProductGroupType } from '../libraries/Utils';
export const ReceiptLineDescriptionEnum = {
    Config: 'Config',
    Aggregation: 'Aggregation',
    Discount: 'Discount',
    Product: 'Product',
    UnselectedOption: 'UnselectedOption',
    ReturnableItem: 'ReturnableItem',
    Pant: 'Pant',
    SelectedOption: 'SelectedOption',
};
const getFields = (orderLine) => {
    return Object.assign(Object.assign(Object.assign({}, ('totalPrice' in orderLine ? { totalPrice: orderLine.totalPrice } : {})), ('quantity' in orderLine ? { quantity: orderLine.quantity } : {})), ('price' in orderLine && !shouldPriceBeHidden(orderLine) ? { price: orderLine.price } : {}));
};
const shouldPriceBeHidden = (orderLine) => {
    var _a, _b, _c, _d, _e;
    return (((_a = orderLine === null || orderLine === void 0 ? void 0 : orderLine.tags2) === null || _a === void 0 ? void 0 : _a.freeQuantity) &&
        ((_e = (_d = (_c = (_b = orderLine.options) === null || _b === void 0 ? void 0 : _b.foreignIds) === null || _c === void 0 ? void 0 : _c.onlinePosRules) === null || _d === void 0 ? void 0 : _d.cart) === null || _e === void 0 ? void 0 : _e.some((r) => !!(r === null || r === void 0 ? void 0 : r.forcedConfig))));
};
const getLabelFromSubLine = (orderLine) => {
    if (orderLine.subLines && orderLine.subLines.length > 0) {
        const product = orderLine.subLines.find((line) => line.type === 'Product');
        if (product && product.discount && product.discount.options.label) {
            return product.discount.options.label;
        }
    }
    return orderLine.name;
};
const flattenDescriptionRecurse = (subLines, result, indent = 1, hasVatCategoryId = false, vatCategoriesMapper = [], addMenuAdditionFields = false) => {
    subLines.forEach((ol) => {
        switch (ol.type) {
            case 'Aggregation':
                result.push(Object.assign(Object.assign({ text: ol.name, includedInMenuPrice: ol.options.includedInMenuPrice, indent }, getFields(ol)), { type: 'Aggregation' }));
                break;
            case 'Product':
                const vatCategoryId = 'vatCategoryId' in ol && ol.vatCategoryId ? ol.vatCategoryId : null;
                const vatCategoryName = 'vatCategoryName' in ol && ol.vatCategoryName ? ol.vatCategoryName : null;
                const vatRatePerMille = 'vatRatePerMille' in ol && ol.vatRatePerMille ? ol.vatRatePerMille : 0;
                const totalVat = 'totalVat' in ol && ol.totalVat ? ol.totalVat : 0;
                const vatCategoryMap = vatCategoriesMapper.find((vatCategory) => vatCategory.vatCategoryId === vatCategoryId);
                const vatReference = vatCategoryMap
                    ? vatCategoryMap.vatReference
                    : alphaCharacters.charAt(vatCategoriesMapper.length);
                if (!vatCategoryMap) {
                    vatCategoriesMapper.push({ vatCategoryId, vatReference });
                }
                result.push(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ text: ol.name, indent }, getFields(ol)), { type: 'Product', productId: ol.productId, isAddon: ol.isAddon }), (vatCategoryId ? { vatCategoryId } : {})), (vatCategoryName ? { vatCategoryName } : {})), (hasVatCategoryId ? { vatRatePerMille, vatReference, totalVat } : {})), (addMenuAdditionFields && ol._isMenuAdditionPart ? { isMenuAdditionPart: ol._isMenuAdditionPart } : {})), (ol.isMenu ? { isPartOfMenu: ol.isMenu } : {})));
                break;
            case 'Config':
                if (ol.name.indexOf('Menu') > -1) {
                }
                else {
                    if (ol.unselectedOptions) {
                        ol.unselectedOptions.forEach((opt) => {
                            result.push(Object.assign({ text: opt.name, indent, isUnselectedOption: true, type: 'UnselectedOption', optionIndex: opt.optionIndex, configId: opt.configId }, (opt.productId ? { productId: opt.productId } : {})));
                        });
                    }
                }
                break;
            case 'ReturnableItem':
                result.push({
                    indent: 0,
                    text: ol.name,
                    type: 'ReturnableItem',
                });
                break;
            case 'Discount':
                result.push({
                    text: ol.name,
                    indent,
                    isDiscount: true,
                    type: 'Discount',
                });
                break;
            case 'Voucher':
                result.push({
                    text: ol.values[0].voucherName,
                    voucherId: ol.values[0].voucherId,
                    indent,
                    type: 'Voucher',
                });
                break;
            case 'CombinatorLine':
                result.push({
                    text: ol.name,
                    type: 'Product',
                    indent: 0,
                    totalPrice: ol.totalPriceAccum,
                    price: ol.totalPrice,
                    quantity: ol.quantity,
                    includePriceToken: true,
                    productIds: ol.productIds,
                });
                break;
            default:
                throw new Error('ShouldNeverHappen');
        }
        if ('subLines' in ol && ol.subLines.length > 0 && ol.type !== 'CombinatorLine') {
            flattenDescriptionRecurse(ol.subLines, result, indent + 1, hasVatCategoryId, vatCategoriesMapper, addMenuAdditionFields);
        }
    });
};
const menuSize = (ol) => {
    const sl = ol.subLines.find((sl) => sl.name === `Menu Size`);
    return sl && 'selectedOptions' in sl && sl.selectedOptions.length > 0 ? sl.selectedOptions[0].name : '';
};
const prunePredicate = (ol) => {
    if (ol.type === 'Aggregation') {
        return OrderLineOperators.PrunePredicateEnum.EXCLUDE_AND_FLATTEN_CHILDREN;
    }
    else {
        return OrderLineOperators.PrunePredicateEnum.INCLUDE;
    }
};
const computeMenuPriceSubstractions = (line, includedInMenuPrice) => {
    var _a, _b;
    if (includedInMenuPrice && 'totalPrice' in line) {
        if (line.totalPriceBefore) {
            const baseMenuPrice = includedInMenuPrice || ((_b = (_a = line.options) === null || _a === void 0 ? void 0 : _a.priceStructure) === null || _b === void 0 ? void 0 : _b.priceInGroup);
            const increasedByPrice = line.totalPriceBefore - baseMenuPrice;
            line.totalPrice = increasedByPrice;
            return line.price - increasedByPrice;
        }
        else {
            const canSubtract = Math.min(line.totalPrice, includedInMenuPrice);
            line.totalPrice = line.totalPrice - canSubtract;
            return canSubtract;
        }
    }
    else {
        let subtractedFromBelow = 0;
        line.subLines.forEach((subline) => {
            subtractedFromBelow += computeMenuPriceSubstractions(subline, line.options.includedInMenuPrice);
        });
        return subtractedFromBelow;
    }
};
const createDecoratedOrderLine = (ol, menuDecoration = {}) => {
    return Object.assign(Object.assign({}, ol), menuDecoration);
};
const adjustForMenuPrices = (orderLines) => {
    return orderLines.map((line) => {
        const totalSubtraction = computeMenuPriceSubstractions(line, 0);
        if (totalSubtraction) {
            const hasPrice = typeof line.price === 'number' && Number.isFinite(line.price);
            if (hasPrice && !line.isMenu) {
                throw AppError.createNewError('CannotUseMenuPricesForProductsWithTotalPrice')
                    .addData('line', line)
                    .addData('totalSubtraction', totalSubtraction);
            }
            return createDecoratedOrderLine(line, {
                price: hasPrice ? line.price : totalSubtraction,
                usesMenuPrice: true,
            });
        }
        return createDecoratedOrderLine(line, {});
    });
};
function appendIsAddon(item) {
    if (isSpecificProductGroupType(item, 'addons') && item.subLines.length > 0) {
        if (item.subLines[0].type === 'Product') {
            item.subLines[0].isAddon = true;
        }
    }
}
const generateReceiptLinesWithAddons = (line) => {
    const linesWithAddons = line.subLines.map((item) => {
        appendIsAddon(item);
        item.subLines.map((product) => {
            product.subLines.map((subProduct) => {
                appendIsAddon(subProduct);
            });
        });
        return item;
    });
    return Object.assign(Object.assign({}, line), { subLines: linesWithAddons });
};
export const mapToReceiptLinesG5 = (topLevelOrderLines, addMenuAdditionFields = false) => {
    const filteredOrderLines = topLevelOrderLines.filter((line) => line.type !== 'Meta');
    const topLevelOrderLines0 = copyObject(filteredOrderLines);
    const topLevelOrderLines1 = adjustForMenuPrices(topLevelOrderLines0).map((line) => generateReceiptLinesWithAddons(line));
    const topLevelOrderLines2 = OrderLineOperators.prune(topLevelOrderLines1, prunePredicate, addMenuAdditionFields);
    const vatCategoriesMapper = [];
    const checkVatCategoryExistence = (ol) => {
        if (ol.vatCategoryId) {
            return true;
        }
        if (ol.subLines) {
            return ol.subLines.some(checkVatCategoryExistence);
        }
        return false;
    };
    const hasVatCategoryId = topLevelOrderLines0.some(checkVatCategoryExistence);
    const receiptLines = topLevelOrderLines2.map((ol) => {
        const vatCategoryId = 'vatCategoryId' in ol ? ol.vatCategoryId : null;
        const vatCategoryMap = vatCategoriesMapper.find((vatCategory) => vatCategory.vatCategoryId === vatCategoryId);
        const vatReference = vatCategoryMap
            ? vatCategoryMap.vatReference
            : alphaCharacters.charAt(vatCategoriesMapper.length);
        const totalVat = 'totalVat' in ol ? ol.totalVat : 0;
        if (!vatCategoryMap && !ol.usesMenuPrice) {
            vatCategoriesMapper.push({ vatCategoryId, vatReference });
        }
        switch (ol.type) {
            case 'Product': {
                const desc = [];
                flattenDescriptionRecurse(ol.subLines, desc, 1, hasVatCategoryId, vatCategoriesMapper, addMenuAdditionFields);
                const isVoucherDiscount = (ol) => {
                    if (ol.discount) {
                        return ol.discount && ol.discount.voucherPattern && ol.discount.voucherPattern.length > 0;
                    }
                    if (ol.subLines) {
                        return ol.subLines.some(isVoucherDiscount);
                    }
                    return false;
                };
                const shouldShowPriceBefore = [
                    Boolean(ol.totalPriceBeforeAccum),
                    Boolean(isVoucherDiscount(ol)),
                    ol.totalPrice !== ol.totalPriceBefore,
                ].every(Boolean);
                const productReceiptLine = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ objectType: 'ReceiptLine', type: 'Product', totalPrice: ol.totalPrice, totalPriceAccum: ol.totalPriceAccum }, (ol.totalPriceBeforeAccum ? { totalPriceBefore: ol.totalPriceBeforeAccum } : {})), { price: ol.price }), (ol.priceBefore ? { priceBefore: ol.priceBefore } : {})), { name: ol.name, quantity: ol.quantity }), (ol.discountQuantity && { discountQuantity: ol.discountQuantity })), (ol.usesMenuPrice ? { usesMenuPrice: ol.usesMenuPrice } : {})), { showPriceBefore: shouldShowPriceBefore, description: desc, menuSize: menuSize(ol), generation: 5, productId: ol.productId, vatRatePerMille: ol.vatRatePerMille }), (vatCategoryId ? { vatCategoryId } : {})), (ol.vatCategoryName ? { vatCategoryName: ol.vatCategoryName } : {})), (hasVatCategoryId && !ol.usesMenuPrice ? { vatReference, totalVat } : {}));
                return productReceiptLine;
            }
            case 'Aggregation': {
                const desc = [];
                flattenDescriptionRecurse(ol.subLines, desc, 1, hasVatCategoryId, vatCategoriesMapper, addMenuAdditionFields);
                const aggregationReceiptLine = {
                    unitType: undefined,
                    objectType: 'ReceiptLine',
                    type: 'Aggregation',
                    totalPriceAccum: ol.totalPriceAccum,
                    price: ol.price,
                    name: ol.name,
                    text: '',
                    totalPrice: 0,
                    textRaw: '',
                    quantity: 1,
                    usesMenuPrice: ol.usesMenuPrice,
                    description: desc,
                    menuSize: menuSize(ol),
                    generation: 5,
                };
                return aggregationReceiptLine;
            }
            case 'ReturnableItem': {
                throw new Error('Not implemented');
            }
            case 'FreeMeal':
            case 'Discount': {
                const d = {
                    totalPrice: ol.totalPrice,
                    totalPriceAccum: ol.totalPrice,
                    tags: ol.tags,
                    name: ol.name,
                    generation: 5,
                    type: ol.type,
                    objectType: 'ReceiptLine',
                };
                return d;
            }
            case 'Meta': {
                const n = {
                    tags: ol.tags,
                    name: ol.name,
                    generation: 5,
                    type: 'Meta',
                    values: ol.values,
                    objectType: 'ReceiptLine',
                };
                return n;
            }
            case 'CombinatorLine': {
                const desc = [];
                flattenDescriptionRecurse(ol.subLines, desc, 1, hasVatCategoryId, vatCategoriesMapper, addMenuAdditionFields);
                const c = Object.assign(Object.assign({ tags: [], objectType: 'ReceiptLine', type: 'CombinatorLine', totalPriceAccum: ol.totalPriceAccum, totalPrice: ol.totalPrice, name: getLabelFromSubLine(ol), quantity: ol.quantity }, (ol.usesMenuPrice ? { usesMenuPrice: ol.usesMenuPrice } : {})), { description: desc, generation: 5 });
                return c;
            }
            case 'Delivery': {
                const d = {
                    totalPrice: ol.totalPrice,
                    totalPriceAccum: ol.totalPrice,
                    tags: ol.tags,
                    name: ol.name,
                    generation: 5,
                    type: 'Delivery',
                    objectType: 'ReceiptLine',
                };
                return d;
            }
            default: {
                throw new Error(`Not implemented for: ${ol.type}`);
            }
        }
    });
    return receiptLines;
};
